import { IconBrandFacebook, IconBrandInstagram, IconBrandX, IconCloudComputing, IconSend, IconServer, IconWorld, IconBrandTiktok, IconBrandYoutube, IconMail } from "@/components/lib/tabler-lucide"
import { FaDiscord } from "react-icons/fa6"

export const settings = {
   // Maintenance mode - disables site for non-staff users
   maintenance_mode: {
      enabled: false,
      message: "We're currently performing scheduled maintenance. Please check back soon!",
      allowed_roles: ["admin", "owner"], // Users with these roles can still access the site
   },
   
   company_name: "Apect - Free 24/7 Online Minecraft Server Hosting",
   website_domain: "www.apect.net",
   billing_url: "/subscriptions",
   socials: {
      email: "support@apect.net",
      phone: "Currently not available",
      other: {
         discord: {
            link: "https://discord.apect.net",
            // Server ID for the live community widget on the home page (needs Server
            // Widget enabled in Discord's Server Settings > Widget).
            guild_id: "1317273068846055535",
            icon: <FaDiscord size="1rem" />
         },
         x: {
            link: "https://x.com/apect56",
            icon: <IconBrandX size="1rem" />
         },
         instagram: {
            link: "https://instagram.com/apect.host",
            icon: <IconBrandInstagram size="1rem" />
         },
         facebook: {
            link: "https://www.apect.net/facebook",
            icon: <IconBrandFacebook size="1rem" />
         },
         tiktok: {
            link: "https://www.tiktok.com/@apect.host",
            icon: <IconBrandTiktok size="1rem" />
         },
         youtube: {
            link: "https://www.youtube.com/@Apect56",
            icon: <IconBrandYoutube size="1rem" />
         },
         email: {
            link: "support@apect.net",
            icon: <IconMail size="1rem" />
         }
      }
   },
   home_page_promotion: {
      enabled: false,
      link: "/minecraft",
   },
   top_banner: {
      enabled: false,
      message: "",
   },
   // Reward video ads - set to false to disable all reward-after-video ads
   reward_ads_enabled: true,
   // YouTube videos on panel home page - set to false to hide the video section entirely
   panel_youtube_videos_enabled: false,
   // YouTube videos to display on panel home page (randomly selected)
   panel_youtube_videos: [
      "https://www.youtube.com/embed/dQw4w9WgXcQ",
   ],
   create_ticket_url: "/panel/tickets",
   translation_system: {
      enabled: true, // Will hide language switcher if disabled
      default_language: "en", // Default language to use if no language is selected
      languages: [
         { flag: '/language_icons/en.png', value: "English", key: 'en' },
         { flag: '/language_icons/fr.svg', value: "Français", key: 'fr' },
         { flag: '/language_icons/es.png', value: "Español", key: 'es' },
      ]
   },
   google_analytics_id: "G-40BWXSCHET", // Google Analytics ID, leave empty if you don't want to use it
   // Google AdSense configuration.
   // These IDs are PUBLIC (they ship in the page HTML), so they live here in
   // settings instead of the .env file. Find them in your AdSense dashboard.
   //   client      -> your publisher ID, e.g. "ca-pub-1234567890123456"
   //   slot_side   -> ad unit slot id used for side + panel banner ads
   //   slot_bottom -> ad unit slot id used for the sticky bottom banner
   // Leave `client` empty to disable all AdSense (script + banners + auto ads).
   google_adsense: {
      enabled: true,
      client: "ca-pub-7722656878630692", // e.g. "ca-pub-1234567890123456"
      slot_side: "6160102947",
      slot_bottom: "6160102947",
   },
   // Google Ad Manager configuration for rewarded video ads on the credit store.
   // These values are PUBLIC (the ad unit path is exposed in the GPT request),
   // so they can safely live in source control beside other site settings.
   google_ad_manager: {
      enabled: true,
      network_id: "23346889002", // e.g. "12345678"
      rewarded_ad_unit: "credit-video-ad", // e.g. "/12345678/rewarded_video" or "rewarded_video"
   },
   color_scheme: {
      force_color_scheme: "dark", // "light", "dark" or "auto"
      default_color_scheme: "dark", // "light", "dark" or "auto"
   },
   hero_panel_image: {
      visible: true,
      light: "/home_image.png",
      dark: "/home_image.png"
   },
   partners_visible: false,
   partners: [
      {
         name: "LiteByte",
         image: "/partners/litebyte.png"
      },
      {
         name: "Avast",
         image: "/partners/avast.svg"
      },
      {
         name: "ASRock",
         image: "/partners/asrock.svg"
      },
      {
         name: "Microsoft",
         image: "/partners/microsoft.svg"
      },
      {
         name: "HP",
         image: "/partners/hp.png"
      },
      {
         name: "Docker",
         image: "/partners/docker.svg"
      },
   ],
   reviews_visible: true,
   reviews: [
      {
         title: "Great Service and Performance",
         message: "It's great and if any promblem is faced then you personally have it fixed!",
         avatar: "https://user-images.trustpilot.com/6a19d47a8dd5c4a9898ce5e7/73x73.png"
      },
      {
         title: "This server host runs 24/7 for free",
         message: "This server host runs 24/7 for free it's the only one I have found and even then it might seem like it has some trade-off but it truly runs 24/7 with no lag or button pushing or anything remember aternos and how it's works ok but starts to lag after a bit this host runs smoother than anything else I've tried I recommend 12 out of 10 best server host yet!",
         avatar: "https://user-images.trustpilot.com/69607a1331cbb94e728ffeaf/73x73.png"
      },
      {
         title: "Great hosting",
         message: "Really well made website, great prices, always online. Keep up the good work for a new host.",
         avatar: "https://user-images.trustpilot.com/69ed75192c172705fa750d31/73x73.png"
      },
      {
         title: "Best server hosting service there is",
         message: "Best hosting service ever. Affordable prices.",
         avatar: "https://user-images.trustpilot.com/69608144d7ccaa942a8ff338/73x73.png"
      },
      {
         title: "Underrated",
         message: "It's very hard to find a hosting like this, no lag, no limitations, i love waht you do keep with the good work man ;D",
         avatar: "https://user-images.trustpilot.com/69e960672c172796c570b99e/73x73.png"
      },
      {
         title: "Great customer support",
         message: "Great customer support. Server runs well",
         avatar: "https://user-images.trustpilot.com/6975004746988411ba725c35/73x73.png"
      },
      {
         title: "Such a great hosting server",
         message: "Such a great hosting server, actually gives what they promise and listens to their users, and had a great time on their discord, chatting and also supporting me through making a server, One of the best hosting servers I’ve tried out so far",
         avatar: "https://user-images.trustpilot.com/69ed37556219144c5c4d7425/73x73.png"
      },
      {
         title: "Hosting was good",
         message: "Hosting was good and fast, the owner was friendly and helpful, overall was a good experience! The website also looks pretty cool.",
         avatar: "https://user-images.trustpilot.com/696082bb31cbb9361190023c/73x73.png"
      },
      {
         title: "Cheap servers with a good owner and…",
         message: "Cheap servers with a good owner and support!",
         avatar: "https://user-images.trustpilot.com/69ebcb975f73f972859444e6/73x73.png"
      },
      {
         title: "best host yet!",
         message: "super great because uhh nice owner, fixed my server even after i offered to fix it myself, has great website, great staff, and VERY cheap servers",
         avatar: "https://user-images.trustpilot.com/69e562140a02e750487e206c/73x73.png"
      },
      {
         title: "Fast performance and actually 24/7",
         message: "The Apect free tier is honestly amazing. Ive never had an easier time setting up a server, and the fact that it is free and always online is so unique and unheard of. At first I was very skeptical of Apect since I didn't think it was possible to have a free server that's always online. However after using it for a few days I have realized how far ahead it is from the other free server hosts, and I could never switch back to Aternos from Apect.",
         avatar: "https://user-images.trustpilot.com/69b87737c9f1762c00db2702/73x73.png"
      },
      {
         title: "This is amazing",
         message: "This is amazing, staff is great, setup is very easy, website is easy and accessible. I really enjoy this and recommend others to use this hosting.",
         avatar: "https://user-images.trustpilot.com/699c0caf3cdc498376cb49e6/73x73.png"
      },
      {
         title: "This is the best server hosting…",
         message: "This is the best server hosting website. Tho there is no European servers its still great.",
         avatar: "https://user-images.trustpilot.com/69988ecdd6c35247715c5101/73x73.png"
      },
      {
         title: "Easiest free server host",
         message: "Very easy to find where the plugins are and also it's a very quick panel, it would be better if the was a tab just for server config but apart from that it was great.",
         avatar: "https://user-images.trustpilot.com/6998018cd6c352a33b5b6b79/73x73.png"
      },
      {
         title: "Great free tier",
         message: "Somehow the free tier is better then my old server I paid $5/month for on my old provider",
         avatar: "https://avatars.githubusercontent.com/u/16?v=4"
      },
      {
         title: "Best mc host",
         message: "its free owner and mods are nice def 6/5 but only could give 5. it has good storage for plugins and work great",
         avatar: "https://user-images.trustpilot.com/6990c14ddcbdacda35b83521/73x73.png"
      },
      {
         title: "ez trize review",
         message: "this is an insane performance server hosting with a very good free tier, 99% uptime on a free tier? this is you answer!, if you are looking for a cheap/free and reliable hosting with good performance this is a good choice for you.",
         avatar: "https://user-images.trustpilot.com/699656ead6c3522657599426/73x73.png"
      },
      {
         title: "You guys are the best i like the setver…",
         message: "You guys are the best i like the setver very much",
         avatar: "https://user-images.trustpilot.com/6996250cd6c3525bfd595e30/73x73.png"
      },
      {
         title: "I used this host and its amazing",
         message: "I used this host and its amazing! Free and optimized and the best ui ever! Everything is good also the specs are good even free ones, my members had a pretty good experience ",
         avatar: "https://user-images.trustpilot.com/69962218b2781ec2d52fd6e9/73x73.png"
      },
      {
         title: "Fire 24/7 hosting and Good support",
         message: "Actully fire Hosting Tho No joke 24/7 Online you can turn of your pc its still online ",
         avatar: "https://user-images.trustpilot.com/65d7709d17d49100127759ac/73x73.png"
      }
   ],
   bento_grid_image: "/support_tickets_image.png",
   bento_grid_image_alt: "Support tickets",

   // Array of blog post IDs from the blogs.js file to display on the home page
   home_page_blogs: [1, 2, 3], // Maximum of 3
   navbar_support_link: "https://discord.apect.net",

   navbar_floating_max_width: "90rem",
   navbar_floating_width_base: "calc(100% - 2rem)",
   navbar_floating_width_sm: "calc(100% - 7rem)",
   navbar_panel_url: "/panel",
   // Navbar links for Discord-style navbar
   navbar_links: [
      { label: 'Forums', href: '/forums' },
      { label: 'Status', href: '/status' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Blogs', href: '/blog' },
      { label: 'FAQ', href: '/faq' },
      { label: 'Contact', href: '/contact-us' },
   ],

   // Compair page configuration
   // Update these values to control what appears in the compair section on /pricing.
   compair_page: {
      title: "Hosting Compair",
      description: "Compare Apect against other hosts across free and paid tiers, support quality, and key platform features.",
      hosts: [
         {
            name: "Apect",
            featured: false,
            free_tier: {
               enabled: true,
               uptime: "Always Online",
               ram: "2 GB",
               cpu: "4 vCPU",
               storage: "5 GB",
            },
            budget_tier: {
               enabled: true,
               price: "$1.00/GB",
               uptime: "100%",
               ram: "DDR4",
               cpu: "4+ vCPU 3.00-4.50  GHz",
               storage: "25+ GB",
            },
            premium_tier: {
               enabled: true,
               price: "$1.50/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9900X",
               storage: "100+ GB",
            },
            extreme_tier: {
               enabled: true,
               price: "$2.00/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9950X",
               storage: "100+ GB",
            },
            quality_support_24_7: true,
            custom_panel: true,
            plugin_mod_installer: true,
            bedrock_support: true,
         },
         {
            name: "PebbleHost",
            featured: false,
            free_tier: {
               enabled: false,
            },
            budget_tier: {
               enabled: true,
               price: "$1.00/GB",
               uptime: "100%",
               ram: "DDR4",
               cpu: "2+ vCPU Ryzen 7 5700X",
               storage: "Unknown",
            },
            premium_tier: {
               enabled: true,
               price: "$2.25/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "2+ vCPU Ryzen 9 9900X",
               storage: "Unknown",
            },
            extreme_tier: {
               enabled: false,
            },
            quality_support_24_7: false,
            custom_panel: false,
            plugin_mod_installer: true,
            bedrock_support: true,
         },
         {
            name: "Aternos",
            featured: false,
            free_tier: {
               enabled: true,
               uptime: "Only when players are online",
               ram: "2 GB",
               cpu: "1 vCPU",
               storage: "4 GB",
            },
            budget_tier: {
               enabled: false,
               price: "$1.00/GB",
               uptime: "100%",
               ram: "DDR4",
               cpu: "4+ vCPU 3.00-4.50  GHz",
               storage: "25+ GB",
            },
            premium_tier: {
               enabled: false,
               price: "$1.50/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9900X",
               storage: "100+ GB",
            },
            extreme_tier: {
               enabled: false,
               price: "$2.00/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9950X",
               storage: "100+ GB",
            },
            quality_support_24_7: false,
            custom_panel: true,
            plugin_mod_installer: false,
            bedrock_support: true,
         },
         {
            name: "ShockByte",
            featured: false,
            free_tier: {
               enabled: false,
               uptime: "Only when players are online",
               ram: "2 GB",
               cpu: "1 vCPU",
               storage: "4 GB",
            },
            budget_tier: {
               enabled: true,
               price: "$3.99/GB",
               uptime: "100%",
               ram: "DDR4",
               cpu: "Unknown",
               storage: "Unknown",
            },
            premium_tier: {
               enabled: false,
               price: "$1.50/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9900X",
               storage: "100+ GB",
            },
            extreme_tier: {
               enabled: false,
               price: "$2.00/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9950X",
               storage: "100+ GB",
            },
            quality_support_24_7: true,
            custom_panel: false,
            plugin_mod_installer: true,
            bedrock_support: true,
         },
         {
            name: "Minehut",
            featured: false,
            free_tier: {
               enabled: true,
               uptime: "4 Hour Daily Limit",
               ram: "1 GB",
               cpu: "1 vCPU",
               storage: "Unknown",
            },
            budget_tier: {
               enabled: true,
               price: "$3.00/GB",
               uptime: "Only when players are online",
               ram: "DDR4",
               cpu: "Unknown",
               storage: "Unknown",
            },
            premium_tier: {
               enabled: false,
               price: "$1.50/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9900X",
               storage: "100+ GB",
            },
            extreme_tier: {
               enabled: false,
               price: "$2.00/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9950X",
               storage: "100+ GB",
            },
            quality_support_24_7: false,
            custom_panel: true,
            plugin_mod_installer: false,
            bedrock_support: true,
         },
         {
            name: "GGServers",
            featured: false,
            free_tier: {
               enabled: false,
               uptime: "4 Hour Daily Limit",
               ram: "1 GB",
               cpu: "1 vCPU",
               storage: "Unknown",
            },
            budget_tier: {
               enabled: true,
               price: "$3.00/GB",
               uptime: "100%",
               ram: "DDR4",
               cpu: "4+ vCPU 3.2-4.0 GHz",
               storage: "SSD",
            },
            premium_tier: {
               enabled: true,
               price: "$6.00/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU 4.4-5 GHz",
               storage: "NVMe",
            },
            extreme_tier: {
               enabled: false,
               price: "$2.00/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9950X",
               storage: "100+ GB",
            },
            quality_support_24_7: true,
            custom_panel: false,
            plugin_mod_installer: true,
            bedrock_support: true,
         },
         {
            name: "Apex",
            featured: false,
            free_tier: {
               enabled: false,
               uptime: "Only when players are online",
               ram: "2 GB",
               cpu: "1 vCPU",
               storage: "4 GB",
            },
            budget_tier: {
               enabled: true,
               price: "$3.75/GB",
               uptime: "100%",
               ram: "DDR4",
               cpu: "Shared Ryzen 7 5800X",
               storage: "NVMe unknown",
            },
            premium_tier: {
               enabled: false,
               price: "$1.50/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9900X",
               storage: "100+ GB",
            },
            extreme_tier: {
               enabled: false,
               price: "$2.00/GB",
               uptime: "100%",
               ram: "DDR5",
               cpu: "4+ vCPU Ryzen 9 9950X",
               storage: "100+ GB",
            },
            quality_support_24_7: true,
            custom_panel: false,
            plugin_mod_installer: true,
            bedrock_support: true,
         },
      ],
   },

   auth: {
      register_path: "/register",
      login_path: "/login",
      account_path: "/account",
      // Where a user lands straight after authenticating (login, Google sign-in, register).
      // Separate from account_path, which is still what the account menu links to.
      post_login_path: "/panel",
      default_avatar_path: "/default_avatar.svg",
      default_admin: "tacu56",
      // Accounts that always have Owner permissions, whatever role is stored on them, and the
      // tag shown next to their name in the admin panel. Only these accounts see the tags and
      // only they can manage each other. Matched by account ID because usernames can be
      // changed. While this is empty, the default_admin username above is used.
      owner_accounts: [
         { id: 1, badge: "Owner" }, // tacu56
         { id: 174, badge: null }, // MuffDog
      ],
   },

   auth_server: {
      jwt_cookie_name: "apect_session",
      jwt_expires_in: "30d",
      jwt_secret_env: "APECT_JWT_SECRET",
      database: {
         type: "mysql",
         sqlite: {
            file_path: "./data/auth.sqlite",
         },
         mysql: {
            host: "127.0.0.1",
            port: 3306,
            user: "apect",
            password_env: "APECT_MYSQL_PASSWORD",
            database: "apect_db",
         }
      },
      email: {
         enabled: true,
         from: "Apect Hosting <no-reply@apect.net>",
         promo_from: "Apect <promo@apect.net>",
         require_email_verification: true,
         smtp: {
            host: "smtp-pulse.com",
            port: 587,
            secure: false,
            user_env: "APECT_SMTP_USER",
            pass_env: "APECT_SMTP_PASS",
         }
      },
      google_oauth: {
         enabled: true,
         client_id: "394873679426-45rtj0bovotolbbv92mojqqlcan19d9p.apps.googleusercontent.com",
         client_secret_env: "APECT_GOOGLE_CLIENT_SECRET",
         redirect_uri: "https://www.apect.net/api/auth/google/callback",
         scopes: ["openid", "email", "profile"],
         state_cookie_name: "apect_google_oauth_state",
      },
      microsoft_oauth: {
         enabled: false, // Set to true when OneDrive OAuth is configured
         client_id_env: "APECT_MICROSOFT_CLIENT_ID",
         client_secret_env: "APECT_MICROSOFT_CLIENT_SECRET",
         redirect_uri: "https://www.apect.net/api/hosting/cloud-accounts/onedrive/callback",
      },
      uploads: {
         avatar_dir: "./data/avatars",
         avatar_max_bytes: 2097152,
         avatar_allowed_mime: ["image/png", "image/jpeg", "image/webp"],
      },
   },

   navbar_dropdown_items: [
      {
         icon: IconSend,
         title: 'Minecraft',
         description: 'Explore our Minecraft Server plans',
         href: '/minecraft'
      },
   ],

   // Forum categories configuration
   forum_categories: [
      { id: 'general', name: 'General', description: 'General topics and casual conversation' },
      { id: 'support', name: 'Support', description: 'Get help with hosting issues' },
      { id: 'suggestions', name: 'Suggestions', description: 'Suggest new features and improvements' },
      { id: 'offtopic', name: 'Off-Topic', description: 'Everything else that doesn\'t fit elsewhere' }
   ],

   footer_links: [
      {
         title: 'GENERAL',
         links: [
            { label: 'Home', link: '/' },
            { label: 'Pricing', link: '/#pricing' },
            { label: 'Blog', link: '/blog' },
            { label: 'FAQ', link: '/faq' },
            { label: 'Contact us', link: '/contact-us' },
            { label: 'Create a ticket', link: '/panel/tickets' },
            { label: 'Join our Discord', link: 'https://discord.apect.net' },
            { label: 'Careers', link: '/careers' },
         ],
      },
      {
         title: 'OUR SERVICES',
         links: [
            { label: 'Minecraft', link: '/minecraft' },
            { label: 'Our Network', link: '/network' },
         ],
      },
      {
         title: 'LEGAL',
         links: [
            { label: 'Terms of Service', link: '/terms-of-service' },
            { label: 'Privacy Policy', link: '/privacy-policy' },
         ],
      },
   ],

   // Minecraft Hosting Configuration
   hosting: {
      // Domain for player server connections (subdomain.domain)
      server_domain: "apect.host",
      
      // Default player head for server icons (Minecraft username)
      default_server_icon: "ItsKami_",
      
      // Player head API URL (use {username} placeholder)
      player_head_api: "https://mc-heads.net/avatar/{username}/128",

      // Credit store custom heads are configured here instead of the admin panel.
      // Upload image files to /public/custom-head-icons as <skin_name>.png.
      custom_player_heads: {
         public_path: "/custom-head-icons",
         catalog: [
            // { skin_name: "dragon-head", name: "Dragon Head", price_credits: 250, is_active: true },
         ],
      },
      
      // Server templates configuration
      server_templates: [
         {
            id: "leaf",
            name: "Vanilla",
            description: "Default Vanilla Minecraft Server.",
            image: "/templates/vanilla.png",
            flag: "leaf",
            comingSoon: false,
         },
         {
            id: "lifesteal",
            name: "Lifesteal",
            description: "Vanilla Minecraft Server with Lifesteal",
            image: "/templates/lifesteal.png",
            flag: "lifesteal",
            comingSoon: false,
         },
         {
            id: "fabric",
            name: "Fabric",
            description: "Fabric Minecraft Server",
            image: "/templates/fabric.png",
            flag: "fabric",
            comingSoon: false,
         },
         {
            // Not shown as a template on the create page - the loader picker covers it.
            // This entry exists so provisioning validates: templateForJarType('neoforge')
            // resolves here, and the container reads TEMPLATE=neoforge for its config files.
            id: "neoforge",
            name: "NeoForge",
            description: "NeoForge Minecraft Server",
            image: "/jars/neoforge.png",
            flag: "neoforge",
            comingSoon: false,
         },
         {
            id: "manhunt",
            name: "Manhunt",
            description: "Pre-configured Manhunt Gamemode",
            image: "/templates/manhunt.png",
            flag: "manhunt",
            comingSoon: false,
         },
         {
            id: "parkour",
            name: "Parkour",
            description: "Pre-configured Parkour Gamemode",
            image: "/templates/vanilla.png",
            flag: "parkour",
            comingSoon: true,
         },
         {
            id: "bedwars",
            name: "Bedwars",
            description: "Pre-configured Bedwars Gamemode",
            image: "/templates/bedwars.png",
            flag: "bedwars",
            comingSoon: true,
         },
         {
            id: "pixelmon",
            name: "Pixelmon",
            description: "Pre-configured Pixelmon Gamemode",
            image: "/templates/pixelmon.png",
            flag: "pixelmon",
            comingSoon: true,
         },
         {
            id: "economy",
            name: "Economy",
            description: "Pre-configured Economy Setup",
            image: "/templates/vanilla.png",
            flag: "economy",
            comingSoon: true,
         },
      ],

      // Hosting plans configuration
      plans: {
         free: {
            name: "Free",
            description: "Perfect for small servers with friends",
            ram: 2,
            storage: 5,
            cpu: 4,
            price_per_gb_ram: 0,
            configurable: false,
         },
         budget: {
            name: "Budget",
            description: "Great value for growing communities",
            ram: { min: 1, max: 32, default: 4 },
            storage: { min: 25, max: 600, default: 25 },
            cpu: { min: 4, max: 16, default: 4 },
            price_per_gb_ram: 1.00,
            configurable: true,
         },
         premium: {
            name: "Premium",
            description: "High performance for serious servers",
            ram: { min: 1, max: 32, default: 8 },
            storage: { min: 25, max: 600, default: 50 },
            cpu: { min: 4, max: 16, default: 6 },
            price_per_gb_ram: 1.50,
            configurable: true,
         },
         extreme: {
            name: "Extreme",
            description: "Maximum power for large networks",
            ram: { min: 1, max: 32, default: 16 },
            storage: { min: 25, max: 600, default: 100 },
            cpu: { min: 4, max: 16, default: 8 },
            price_per_gb_ram: 2.00,
            configurable: true,
         },
      },

      // Pricing configuration
      pricing: {
         free_storage_gb: 25,
         price_per_25gb_storage: 1.00,
         free_cpu_cores: 4,
         price_per_extra_core: 1.00,
      },

      // Redis configuration (for pub/sub with nodes)
      redis: {
         host_env: "APECT_REDIS_HOST",
         port_env: "APECT_REDIS_PORT",
         password_env: "APECT_REDIS_PASSWORD",
         default_host: "127.0.0.1",
         default_port: 6379,
      },

      // Stripe configuration
      stripe: {
         enabled: true, // Set to true when Stripe is configured, false shows "Coming Soon"
         publishable_key: null, // Will be loaded from API endpoint at runtime
         publishable_key_env: "APECT_STRIPE_PUBLISHABLE_KEY",
         secret_key_env: "APECT_STRIPE_SECRET_KEY",
         webhook_secret_env: "APECT_STRIPE_WEBHOOK_SECRET",
      },

      // PayPal configuration
      paypal: {
         enabled: true, // Set to true when PayPal is configured, false shows "Coming Soon"
         client_id_env: "APECT_PAYPAL_CLIENT_ID",
         client_secret_env: "APECT_PAYPAL_CLIENT_SECRET",
         mode: "live", // "sandbox" or "live" - use "sandbox" with sandbox credentials, "live" with production credentials
      },

      // Console log limits (to prevent database overflow)
      console: {
         max_lines_per_server: 5000,
         max_line_length: 1000,
      },

      // Free tier server limits per user role
      free_server_limits: {
         default: 1,    // Normal users
         linked: 3,     // Discord-linked users
         booster: 5,    // Server boosters
         staff: -1,     // Unlimited (-1)
         admin: -1,     // Unlimited (-1)
      },

      // Node selection configuration
      node_selection: {
         min_free_storage_gb: 10,
      },
   },
}